import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {emailCaptcha,smsCaptcha,smssigns, sendLoading} = api

/**
 *发送邮件
 */
export async function sendEmailCaptcha(params) {
    return request({url: emailCaptcha, method: 'post', data: params,})
}
/**
 *发送短信
 */
export async function sendSmsCaptcha(params) {
    return request({url: smsCaptcha, method: 'post', data: params,})
}
/**
 *查询短信签名
 */
export async function findSmssigns(params) {
    return request({url: smssigns, method: 'get', data: params,})
}

export async function findSendLoading() {
    return request({url: sendLoading, method: 'get'})
}



// WEBPACK FOOTER //
// ./src/services/sendEmailSms.js